

type HttpStatusCodeMessage = Record<number, string>;

export const errorCodeMessages: HttpStatusCodeMessage = {
    400: "Bad request",
    403: "Forbidden",
    404: "The requested page was not found."
}
